import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnTargetVariant1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 49,
			height: 49,
			rx: 24.5,
			fill: "currentColor",
			fillOpacity: .1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 49,
			height: 49,
			rx: 24.5,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.61523 8.0293L8.73655 10.1506C9.12708 10.5411 9.76024 10.5411 10.1508 10.1506C10.5413 9.76009 10.5413 9.12693 10.1508 8.7364L8.02945 6.61508L6.61523 8.0293Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.3848 41.9707L41.2634 39.8494C40.8729 39.4589 40.2398 39.4589 39.8492 39.8494C39.4587 40.2399 39.4587 40.8731 39.8492 41.2636L41.9706 43.3849L43.3848 41.9707Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.9707 6.61523L39.8494 8.73655C39.4589 9.12708 39.4589 9.76024 39.8494 10.1508C40.2399 10.5413 40.8731 10.5413 41.2636 10.1508L43.3849 8.02945L41.9707 6.61523Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.0293 43.3848L10.1506 41.2634C10.5411 40.8729 10.5411 40.2398 10.1506 39.8492C9.76009 39.4587 9.12693 39.4587 8.7364 39.8492L6.61508 41.9706L8.0293 43.3848Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.6195 14.25C45.6059 17.6905 46.6002 21.6141 46.492 25.5853C46.3839 29.5566 45.1775 33.4202 43.0068 36.7475",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.75 43.6195C32.5095 45.4905 28.8367 46.4833 25.0949 46.4998C21.3531 46.5163 17.6718 45.556 14.4148 43.7137",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.79739 34.67C4.27136 31.6397 3.48419 28.2912 3.50024 24.8983C3.5163 21.5054 4.33512 18.1645 5.88976 15.1487",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2338 5.84609C18.2565 4.30489 21.6011 3.50095 24.994 3.5C28.3869 3.49905 31.7319 4.30112 34.7554 5.84063",
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgOnTargetVariant1;
